import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.resize()
  }

  resize() {
    const scrollLeft = window.scrollX
    const scrollTop = window.scrollY
    
    this.element.style.height = `${this.element.scrollHeight}px`
    this.element.style.overflow = "hidden"
    this.element.style.height = "auto"
    
    const scrollHeight = this.element.scrollHeight
    this.element.style.height = `${scrollHeight + 10}px`
    
    window.scrollTo(scrollLeft, scrollTop)
  }
}